<template>
  <!-- we currently don't have a dedicated logout page -->
  <!-- this component is here so that we can set up the logout route -->
  <p />
</template>

<script>
export default {};
</script>
